import { render, staticRenderFns } from "./bottomFooter.vue?vue&type=template&id=df2b7138&scoped=true&"
import script from "./bottomFooter.vue?vue&type=script&lang=js&"
export * from "./bottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./bottomFooter.vue?vue&type=style&index=0&id=df2b7138&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2b7138",
  null
  
)

export default component.exports